import { withDirectives as _withDirectives, resolveDirective as _resolveDirective, isVNode as _isVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue";
import { fetchExhibitionDetail, updateExbitionShareInfo, getSortwareDownload } from "@/api/exibition";
import request from "@/utils/request/index";
import useClipboard from "vue-clipboard3";
const {
  toClipboard
} = useClipboard();
import { ref } from "vue";
import "./style.less";
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !_isVNode(s);
}
const loading = ref(false);
const shareBody = defineComponent({
  inheritAttrs: false,
  props: ["exbitionInfo"],
  setup(props, {
    emit
  }) {
    const exbitionInfo = reactive({
      shareTitle: "",
      shareCoverImage: "",
      id: ""
    });
    watchEffect(() => {
      if (props.exbitionInfo.value) {
        Object.assign(exbitionInfo, props.exbitionInfo.value);
      }
    });
    const handleChange = data => {};
    const handleSuccess = data => {
      exbitionInfo.shareCoverImage = data.data;
    };
    const handleCoverSuccess = data => {
      exbitionInfo.coverImageUrl = data.data;
    };
    const handleSumbit = () => {
      updateExbitionShareInfo({
        id: exbitionInfo.id,
        shareTitle: exbitionInfo.shareTitle,
        shareCoverImage: exbitionInfo.shareCoverImage,
        coverImageUrl: exbitionInfo.coverImageUrl
      }, {
        message: "修改成功",
        loading
      });
    };
    return () => _createVNode("div", {
      "class": "share-body"
    }, [_createVNode("div", {
      "class": "flex-column share-title"
    }, [_createVNode("p", null, [_createTextVNode("\u5206\u4EAB\u6807\u9898")]), _createVNode(_resolveComponent("el-input"), {
      "modelValue": exbitionInfo.shareTitle,
      "onUpdate:modelValue": $event => exbitionInfo.shareTitle = $event
    }, null)]), _createVNode("div", {
      "style": {
        marginBottom: "30px"
      }
    }, [_createVNode("p", null, [_createTextVNode("\u5206\u4EAB\u5C01\u9762")]), _createVNode(_resolveComponent("el-upload"), {
      "class": "avatar-uploader vc vh",
      "show-file-list": false,
      "on-success": handleSuccess,
      "on-change": handleChange,
      "accept": "image/*",
      "drag": true
    }, {
      default: () => [exbitionInfo.shareCoverImage ? _createVNode("img", {
        "src": exbitionInfo.shareCoverImage,
        "class": "avatar"
      }, null) : _createVNode("div", {
        "class": "vc flex-column"
      }, [_createVNode("img", {
        "src": require("@/assets/img/icons/upload-icon.png"),
        "class": "upload-icon"
      }, null), _createVNode("p", null, [_createTextVNode("\u4E0A\u4F20\u7D20\u6750")])])]
    })]), _createVNode("div", null, [_createVNode("p", null, [_createTextVNode("\u5C55\u9879\u5C01\u9762")]), _createVNode(_resolveComponent("el-upload"), {
      "class": "avatar-uploader vc vh",
      "show-file-list": false,
      "on-success": handleCoverSuccess,
      "accept": "image/*",
      "drag": true
    }, {
      default: () => [exbitionInfo.coverImageUrl ? _createVNode("img", {
        "src": exbitionInfo.coverImageUrl,
        "class": "avatar"
      }, null) : _createVNode("div", {
        "class": "vc flex-column"
      }, [_createVNode("img", {
        "src": require("@/assets/img/icons/upload-icon.png"),
        "class": "upload-icon"
      }, null), _createVNode("p", null, [_createTextVNode("\u4E0A\u4F20\u7D20\u6750")])])]
    })]), _createVNode("div", {
      "class": "el-dialog__footer"
    }, [_createVNode(_resolveComponent("el-button"), {
      "type": "default",
      "onClick": () => emit("close")
    }, {
      default: () => [_createTextVNode("\u53D6\u6D88")]
    }), _createVNode(_resolveComponent("el-button"), {
      "type": "primary",
      "onClick": handleSumbit
    }, {
      default: () => [_createTextVNode("\u63D0\u4EA4")]
    })])]);
  }
});
const setupApplication = defineComponent({
  inheritAttrs: false,
  props: ["exbitionInfo"],
  setup(props, {
    emit
  }) {
    const copyEvent = async () => {
      try {
        await toClipboard(props.exbitionInfo.value?.id);
        ElMessage({
          message: "复制成功",
          type: "success"
        });
      } catch (e) {
        console.error(e);
      }
    };
    let link = "";
    const handleDown = async () => {
      if (!link) {
        const {
          data
        } = await getSortwareDownload();
        link = data;
      }
      request.download(link).then(({
        data
      }) => {
        if ("download" in document.createElement("a")) {
          //非IE下载
          const a = document.createElement("a"); //创建一个a标签
          a.download = link.split("/")[link.split("/").length - 1] + "." + link.split(".")[link.split(".").length - 1]; //指定文件名称
          a.href = window.URL.createObjectURL(new Blob([link]));
          a.click(); //通过点击触发
          URL.revokeObjectURL(a.href); //释放URL 对象
        }
      });
    };

    return () => _createVNode("div", {
      "id": "setupApplication"
    }, [_createVNode("p", {
      "style": "text-align:center"
    }, [_createTextVNode("\u5B89\u88C5\u6D41\u7A0B")]), _createVNode("img", {
      "class": "tips-img",
      "src": require("@/assets/img/workplace/tips.png")
    }, null), _createVNode("div", {
      "style": "column-gap:20px;",
      "class": "vc"
    }, [_createVNode("span", {
      "style": "flex-shrink:0;line-height:3;"
    }, [_createTextVNode("\u5C55\u9879\u7F16\u7801")]), _createVNode(_resolveComponent("el-input"), {
      "disabled": true,
      "value": props.exbitionInfo.value?.id
    }, null), _createVNode(_resolveComponent("el-button"), {
      "type": "text",
      "onClick": copyEvent
    }, {
      default: () => [_createTextVNode("\u590D\u5236")]
    })]), _createVNode("div", {
      "style": "column-gap:20px;margin-top:30px;justify-content:flex-start;",
      "class": "vh"
    }, [_createVNode("span", null, [_createTextVNode("\u5E94\u7528\u4E0B\u8F7D")]), _createVNode("div", {
      "class": "download-btn vh vc"
    }, [_createVNode("img", {
      "src": require("@/assets/img/icons/file.png")
    }, null)]), _createVNode(_resolveComponent("el-button"), {
      "type": "text",
      "style": "align-self: self-end;color:rgba(65, 107, 244, 1)",
      "onClick": handleDown
    }, {
      default: () => [_createTextVNode("\u4E0B\u8F7D")]
    })])]);
  }
});
const configDialog = defineComponent({
  props: ["show", "id"],
  setup(props, {
    emit
  }) {
    const handleClose = () => {
      emit("close");
    };
    const tabList = ref([{
      label: "配置信息",
      name: "0"
    }, {
      label: "应用安装",
      name: "1"
    }]);
    const activeTab = ref("0");
    const id = unref(props.id);
    const exbitionInfo = ref();
    fetchExhibitionDetail({
      id
    }, {
      loading
    }).then(({
      data
    }) => {
      exbitionInfo.value = data;
    });
    return () => _createVNode(_resolveComponent("el-dialog"), {
      "modelValue": props.show,
      "width": "52%",
      "before-close": handleClose,
      "id": "configDialog",
      "class": "dialog-theme",
      "append-to-body": true
    }, {
      header: () => {
        let _slot;
        return _createVNode(_resolveComponent("el-tabs"), {
          "modelValue": activeTab.value,
          "onUpdate:modelValue": $event => activeTab.value = $event
        }, _isSlot(_slot = tabList.value.map(x => {
          return _createVNode(_resolveComponent("el-tab-pane"), {
            "class": "notice-tabs-pane",
            "name": x.name,
            "label": x.label
          }, null);
        })) ? _slot : {
          default: () => [_slot]
        });
      },
      default: () => {
        switch (activeTab.value) {
          case "0":
            return _withDirectives(_createVNode(shareBody, {
              "exbitionInfo": exbitionInfo,
              "onClose": () => emit("close")
            }, null), [[_resolveDirective("loading"), loading.value]]);
          case "1":
            return _withDirectives(_createVNode(setupApplication, {
              "exbitionInfo": exbitionInfo,
              "onClose": () => emit("close")
            }, null), [[_resolveDirective("loading"), loading.value]]);
        }
      }
    });
  }
});
export const useConfig = () => {
  const showConfig = ref(false);
  return {
    showConfig,
    configDialog
  };
};